import { z } from 'zod';
export const HealthResponse = z
    .object({
    ok: z.literal(true),
    service: z.string().min(1),
    version: z.string().min(1),
    uptimeSec: z.number().int().nonnegative(),
    details: z.record(z.string(), z.unknown()).optional(),
})
    .strict();
export const schemas = {
    'health.v1': HealthResponse,
};
//# sourceMappingURL=health.js.map